/**
 * Connection state model for WebSocket connections
 */

import { CONNECTION_STATES, AUDIO_FORMATS } from '../enums/websocketMessageTypes.js';

export class ConnectionState {
  constructor() {
    this.state = CONNECTION_STATES.IDLE;
    this.conversationId = null;
    this.agentOutputAudioFormat = AUDIO_FORMATS.PCM_16000;
    this.userInputAudioFormat = AUDIO_FORMATS.PCM_16000;
    this.isReadyForAudio = false;
    this.error = null;
    this.lastPingTime = null;
    this.connectionTime = null;
  }

  setState(newState) {
    const previousState = this.state;
    this.state = newState;
    
    // Auto-set connection time when connecting
    if (newState === CONNECTION_STATES.CONNECTED) {
      this.connectionTime = Date.now();
      this.isReadyForAudio = true;
    }
    
    // Clear connection time when disconnecting
    if (newState === CONNECTION_STATES.DISCONNECTED || newState === CONNECTION_STATES.ERROR) {
      this.isReadyForAudio = false;
      this.connectionTime = null;
    }

    return previousState;
  }

  setConversationMetadata({ conversationId, agentOutputAudioFormat, userInputAudioFormat }) {
    this.conversationId = conversationId;
    this.agentOutputAudioFormat = agentOutputAudioFormat || this.agentOutputAudioFormat;
    this.userInputAudioFormat = userInputAudioFormat || this.userInputAudioFormat;
    this.isReadyForAudio = true;
    
  }

  setError(error) {
    this.error = error;
    this.setState(CONNECTION_STATES.ERROR);
  }

  clearError() {
    this.error = null;
  }

  isConnected() {
    return this.state === CONNECTION_STATES.CONNECTED && this.isReadyForAudio;
  }

  isConnecting() {
    return this.state === CONNECTION_STATES.CONNECTING;
  }

  isIdle() {
    return this.state === CONNECTION_STATES.IDLE;
  }

  isError() {
    return this.state === CONNECTION_STATES.ERROR;
  }

  getConnectionDuration() {
    if (!this.connectionTime) {
      return 0;
    }
    return Date.now() - this.connectionTime;
  }

  reset() {
    this.state = CONNECTION_STATES.IDLE;
    this.conversationId = null;
    this.agentOutputAudioFormat = AUDIO_FORMATS.PCM_16000;
    this.userInputAudioFormat = AUDIO_FORMATS.PCM_16000;
    this.isReadyForAudio = false;
    this.error = null;
    this.lastPingTime = null;
    this.connectionTime = null;
  }

  // For debugging and logging
  toJSON() {
    return {
      state: this.state,
      conversationId: this.conversationId,
      agentOutputAudioFormat: this.agentOutputAudioFormat,
      userInputAudioFormat: this.userInputAudioFormat,
      isReadyForAudio: this.isReadyForAudio,
      error: this.error,
      connectionDuration: this.getConnectionDuration()
    };
  }
}